import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index'

// main.ts
import 'virtual:uno.css'
import './assets/scss/base.scss'

//@ts-ignore
createApp(App).use(router).mount('#app')
